<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table fixed-header height="750px"  
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.TransactionCode }}</td>
                <td>{{ item.TransactionCodeVN }}</td>
                <td v-if="!isDepositOrder">{{ item.OrderID > 0 ? (item.PackageType == 0 ? 'MD' : 'KG') + item.OrderID : ''}}</td>
                <td>{{ item.Username }}</td>
                <td>{{ item.ProductType | display_value(product_types) }}</td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.ProductNumber" large lazy persistent @save="saveItem({'ID': item.ID, 'ProductNumber': item.ProductNumber})">
                    <div>{{ item.ProductNumber | currency }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.ProductNumber" type="number" step="1" :label="isChinessLanguage ? '数量' : 'Số lượng'" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.ChinaWeight" large lazy persistent @save="saveItem({'ID': item.ID, 'ChinaWeight': item.ChinaWeight})">
                    <div>{{ item.ChinaWeight | currency('', 1) }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.ChinaWeight" type="number" step=".1" :label="isChinessLanguage ? '重量' : 'Cân nặng'" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.ChinaLength" large lazy persistent @save="saveItem({'ID': item.ID, 'ChinaLength': item.ChinaLength})">
                    <div>{{ item.ChinaLength | currency }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.ChinaLength" type="number" step="1" :label="isChinessLanguage ? '长' : 'Dài'" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.ChinaWidth" large lazy persistent @save="saveItem({'ID': item.ID, 'ChinaWidth': item.ChinaWidth})">
                    <div>{{ item.ChinaWidth | currency }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.ChinaWidth" type="number" step="1" :label="isChinessLanguage ? '宽' : 'Rộng'" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog :return-value.sync="item.ChinaHeight" large lazy persistent @save="saveItem({'ID': item.ID, 'ChinaHeight': item.ChinaHeight})">
                    <div>{{ item.ChinaHeight | currency }}</div>
                    <template v-slot:input>
                      <v-text-field v-model="item.ChinaHeight" type="number" step="1" :label="isChinessLanguage ? '高' : 'Cao'" single-line autofocus></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td class="text-end">
                  <v-edit-dialog
                    :return-value.sync="item.ChinaFeeShip"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'ChinaFeeShip': item.ChinaFeeShip})"
                  >
                    <div>{{ item.ChinaFeeShip | currency('', 1)}}</div>
                    <template v-slot:input>
                      <v-text-field
                        v-model="item.ChinaFeeShip"
                        type="number"
                        step=".1"
                        :label="isChinessLanguage ? '到付' : 'Phí ship'"
                        single-line
                        autofocus
                      ></v-text-field>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-if="!exportMenu && (item.BigPackageID == 0 || getBigPackage(item.BigPackageID) != '')">
                  <v-edit-dialog
                    :return-value.sync="item.BigPackageID"
                    large
                    lazy
                    persistent
                    @save="saveItem({'ID': item.ID, 'BigPackageID': item.BigPackageID})"
                  >
                    <div>{{ item.PackageCode }}</div>
                    <template v-slot:input>
                      <v-select
                        :items="packages"
                        v-model="item.BigPackageID"
                        item-text="PackageCode"
                        item-value="ID"
                        v-on:change="item.PackageCode = getBigPackage(item.BigPackageID)"
                      ></v-select>
                    </template>
                  </v-edit-dialog>
                </td>
                <td v-else>
                  {{item.PackageCode}}
                </td>
                <td>{{ item.StoreCNImportDate | display_date }}</td>
                <td v-if="!exportMenu">{{ item.PackDate | display_date }}</td>
                <td v-if="exportMenu">{{ item.StoreCNExportDate | display_date }}</td>
                <td class="truncate" v-if="!exportMenu">
                  <v-edit-dialog :return-value.sync="item.StoreCNNote" large lazy persistent @save="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote})">
                      <v-tooltip top right max-width="250">
                          <template v-slot:activator="{ on }">
                              <span v-on="on">{{ item.StoreCNNote }}</span>
                          </template>
                          <span>{{ item.StoreCNNote }}</span>
                      </v-tooltip>
                      <template v-slot:input>
                          <v-textarea v-model="item.StoreCNNote" :label="isChinessLanguage ? '笔记' : 'Ghi chú'" single-line autofocus></v-textarea>
                      </template>
                  </v-edit-dialog>
                </td>
                <td class="text-center" v-if="!exportMenu">
                  <v-icon small color="#dc3545" @click="printTransaction(item.ID)">fa-print</v-icon>
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon v-on="on" v-if="(storeRole & 4)" medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </template>
                      <span>Xóa mã bill</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <store-popup
        :dialogStoreManager="dialogStoreManager"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></store-popup>
      <v-dialog v-model="dialogImport" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="oee-theme">
            <v-btn icon dark @click="dialogImport = false">
              <v-icon>fa-times-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{importStep == 0 ? 'Import thông tin kiện' : 'Xác minh dữ liệu'}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <!-- <v-flex lg6 md6 sm12 pt-3 v-if="importStep == 0">
                  <v-autocomplete label="Khách hàng" v-model="importUID" :items="customers" item-text="FullName" item-value="ID"></v-autocomplete>
                </v-flex> -->
                <v-checkbox label="Tạo đơn ký gửi cho khách hàng tương ứng" v-model="createDepositOrder"></v-checkbox>
                <v-flex lg12 md12 sm12 xs12 pt-3 v-if="importStep == 0">
                  <a href="/package_import_template.xlsx">File mẫu</a>
                  <v-textarea outlined rows='30' label="Copy dữ liệu từ excel" v-model="dataImport"></v-textarea>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12 pt-3 v-else>
                  <v-data-table fixed-header height="750px"   :headers="importHeaders" :items="importItems" :items-per-page="15" class="elevation-1"></v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1 white--text" @click="importPreview()" v-if="importStep == 0">Tiếp theo</v-btn>
            <v-btn color="blue darken-1 white--text" @click="importStep = 0" v-if="importStep == 1">Quay lại</v-btn>
            <v-btn color="red darken-1 white--text" @click="importTransaction" v-if="importStep == 1">Nhập dữ liệu</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="appLoading" z-index="999999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import store from "@/components/popups/store";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';

export default {
  components: {
    "hpo-filter": Filtering,
    "store-popup": store
  },
  props: ["exportMenu"],
  data() {
    return {
      isDepositOrder: configs.SYSTEM_TYPE != 'order',
      pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "storemanager_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogStoreManager: false,
      dialogEditTranCode: false,
      dialogImport: false,
      createDepositOrder: false,
      dataImport: '',      
      importUID: 0,
      importStep: 0,
      appLoading: false,
      importHeaders: [
        {
          text: this.isChinessLanguage ? "" : "Mã kiện",
          value: "TransactionCode"
        },
        {
          text: this.isChinessLanguage ? "" : "Loại hàng",
          value: "ProductType"
        },
        {
          text: this.isChinessLanguage ? "" : "Khách hàng",
          value: "Username"
        },
        {
          text: this.isChinessLanguage ? "" : "Ngày nhập kho TQ",
          value: "StoreCNImportDate"
        },
        {
          text: this.isChinessLanguage ? "" : "Cân nặng",
          value: "ChinaWeight"
        },
        {
          text: this.isChinessLanguage ? "" : "Khối",
          value: "Volume"
        },
        {
          text: this.isChinessLanguage ? "" : "Ship nội địa",
          value: "ChinaFeeShip"
        },
        {
          text: this.isChinessLanguage ? "" : "Gia cố",
          value: "FeeFragileGoods"
        },
        {
          text: this.isChinessLanguage ? "" : "Phí khác",
          value: "FeeOther"
        }
      ],
      importItems: []
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    storeRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2)});
    },
    product_types() {
      let header_item = _.find(this.headers, { value: "ProductType" });
      if (header_item) {
          header_item.values = this.product_types;
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.all.data,
      total_rows: state => state.orderTransaction.all.total,
      currentItem: state => state.orderTransaction.selected,
      loading: state => state.orderTransaction.loading,
      packages: state => state.bigPackage.inTQ,
      customers: state => state.customer.master.data,
      configuration: state => state.configuration.selected
    }),
    storeRole() {
      return this.$store.state.authentication.role.StoreCN;
    },
    isChinessLanguage() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ && this.$store.state.authentication.user.ischinesslanguage;
    },
    param() {
      let pr = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if(pr.pagination.sortBy == 'ID') {
        pr.pagination.sortBy = this.exportMenu ? ['StoreCNExportDate'] : ['StoreCNImportDate'];
      }
      if(!this.exportMenu) {
        pr.filter.push({
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
          condition: "equal"
        });
      }
      else { 
        pr.filter.push({
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DANG_VE_VN,
          condition: "equal"
        });
      }
      return pr;
    },
    product_types() {
      return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
    },
    headers() {
      let tmp = [
        {
          text: this.isChinessLanguage ? "单号" : "Mã bill",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "内部单号" : "Mã nội bộ",
          value: "TransactionCodeVN",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "客户名" : "Khách hàng",
          value: "Username",
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: this.isChinessLanguage ? "分类" : "Loại hàng",
          value: "ProductType",
          filterable: true,
          values: [],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: this.isChinessLanguage ? "数量" : "Số lượng",
          value: "ProductNumber",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "重量" : "Cân nặng",
          value: "ChinaWeight",
          filterable: true,
          decimal: 1,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "长" : "Dài",
          value: "ChinaLength",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "宽" : "Rộng",
          value: "ChinaWidth",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "高" : "Cao",
          value: "ChinaHeight",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: this.isChinessLanguage ? "到付" : "Phí ship",
          value: "ChinaFeeShip",
          align: "end",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ];
      if(!this.isDepositOrder) {
        temp_headers.splice(2, 0, {
          text: this.isChinessLanguage ? "订单号" : "Mã đơn",
          value: "OrderID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        });
      }
      if(!this.exportMenu) {
        tmp.push(
          {
            text: this.isChinessLanguage ? "包裹编号" : "Mã bao hàng",
            value: "PackageCode",
            filterable: true,
            quickSearch: true,
            dataType: configs.DATA_TYPE["String"]
          }
        )
      }
      tmp.push(
        {
          text: this.isChinessLanguage ? "入仓日期" : "Ngày nhập kho",
          value: "StoreCNImportDate",
          filterable: true,
          dataType: configs.DATA_TYPE["Date"]
        }
      )
      if(!this.exportMenu) {
        tmp.push(
          {
            text: this.isChinessLanguage ? "打包日期" : "Ngày đóng bao",
            value: "PackDate",
            filterable: true,
            dataType: configs.DATA_TYPE["Date"]
          }
        )
      }
      if(this.exportMenu) {
        tmp.push(
          {
            text: this.isChinessLanguage ? "出货日期" : "Ngày xuất kho",
            value: "StoreCNExportDate",
            filterable: true,
            dataType: configs.DATA_TYPE["Date"]
          }
        )
      }
      if(!this.exportMenu) {
        tmp.push(
          {
            text: this.isChinessLanguage ? "笔记" : "Ghi chú",
            value: "StoreCNNote",
            filterable: true,
            dataType: configs.DATA_TYPE["String"]
          }
        )
        tmp.push(
          {
            text: this.isChinessLanguage ? "操作" : "Thao tác",
            value: "",
            align: "center",
            sortable: false,
            filterable: false
          }
        )
      }
      return tmp;
    }
  },
  methods: {
    filter_data: function() {
      this.$store.dispatch("bigPackage/getListInTQ");
      this.$store.dispatch("orderTransaction/getList", this.param);
      this.getCustomerList();
      this.appLoading = false;
    },
    gotoDetail: function(id) {
      let item = _.find(this.items, { ID: id });
      this.$store.commit("orderTransaction/setDetail", { data: item });
      this.dialogEditTranCode = true;
    },
    deleteItem: function(id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      // Bỏ qua event nếu call từ menu xuất kho tq
      if(this.exportMenu) {
        return;
      }
      if(this.storeRole & 2) {
        this.$store.commit("orderTransaction/setDetail", {
          data: {
            ID: 0,
            TransactionCode: "",
            ChinaFeeShip: 0,
            ProductType: -1
          }
        });
        this.dialogStoreManager = true;
      }
      else {
        sendErrorNotice("Bạn không có quyền thêm mới!");
      }
    },
    saveItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          ...item,
          'TransactionView': 'store_tq'
        },
        id: item.ID,
        param: this.param
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogEditTranCode = false;
    },
    closePopup() {
      this.dialogStoreManager = false;
      this.filter_data();
    },
    getBigPackage(bigPackageID) {
      const item = _.find(this.packages, {ID: bigPackageID});
      return item ? item.PackageCode : '';
    },
    importData() {
      this.dataImport = '';
      this.importItems = [];
      this.dialogImport = true;
    },
    importPreview(){
      this.importItems = [];
      let rows = this.dataImport.split("\n");
      if(rows.length <= 1){
        sendErrorNotice('Không tìm thấy dữ liệu import.')
        return;
      }
      let header = rows[0].split("\t");
      let props = [];
      for (let i = 0; i < header.length; i++) {
        let element = _.find(this.importHeaders, function (item) {
          return item.text.toLowerCase() === header[i].toLowerCase();
        });
        props.push(element ? element.value : 'unknown');
      }

      if(!props.includes('TransactionCode')) {
        sendErrorNotice('Không tìm thấy dữ liệu import.')
        return;
      }
      this.importStep = 1;
      for (let i = 1; i < rows.length; i++) {
        let item = rows[i].split("\t");
        if(item.length == 0 || item[0] == '') {
          continue;
        }
        let importItem = {};
        for (let j = 0; j < props.length; j++) {
          let prop = props[j];
          if(prop !== 'unknown') {
            let val = item[j].replace(/\s+/g, ' ').trim();
            if(val != '') {
              importItem[prop] = val;
            }
          }
        }
        this.importItems.push(importItem);
      }
    },
    importTransaction() {
      this.importItems.forEach(element => {      
        if(element.Username) {
            let conf = _.find(this.customers, function (item) {
                let ret = this.isDepositOrder ? item.CustomerCode.normalize('NFD').toLowerCase() === element.Username.normalize('NFD').toLowerCase() : item.Username.normalize('NFD').toLowerCase() === element.Username.normalize('NFD').toLowerCase();
                return ret;
            });
            if(conf) {
                element.UID = conf.ID;
            }
            else {
                delete element.UID;
            }
        }
        if(element.ProductType) {
            let conf = _.find(this.product_types, function (item) {
                let ret = item.name.normalize('NFD').toLowerCase() === element.ProductType.normalize('NFD').toLowerCase();
                return ret;
            });
            if(conf) {
                element.ProductType = conf.value;
            }
            else {
                delete element.ProductType;
            }
        }
        if(this.importUID > 0) {
          element.UID = this.importUID;
        }
      });
      this.appLoading = true;
      this.$store.dispatch("orderTransaction/import", {'Transactions': this.importItems, 'CreateDepositOrder': this.createDepositOrder});
      this.dialogImport = false;
      this.importStep = 0;
      this.importUID = 0;
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "CustomerCode"]
      });
    },
    printTransaction(id) {
      this.appLoading = true;
      request_detail('order_transactions/print', ret => {
        let item = ret.data;
        this.appLoading = false;
        const frame_printing = print_transaction_v2(item, this.$store.state.authentication.user.username, true);
        var doc = document.getElementById('print_frame').contentWindow.document;
        doc.open();
        doc.write(frame_printing);
        doc.close();
        setTimeout(function(){ window.frames["print_frame"].window.print(); }, 1000);
      }, Vue.http, id, this.$store.state.authentication.token);
    }
  },
  mounted() {
    this.$store.dispatch("configuration/getDetail", 1);
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.storeRole & 2), invisibleSaveButton: this.isDepositOrder});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("REQUEST_SAVE_DATA", this.importData);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          'RequestAction': 'DEL',
          'TransactionView': 'store_cn'
        },
        'id': id,
        param: this.param
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("REQUEST_SAVE_DATA", this.importData);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
